import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { DateRange, KeyDeal, Scope, SignedInCompany } from "@revelate/types";
import { KeyDealsDataTable, getKeyDealsColumns } from "./data-table";
import { format } from "date-fns";

interface KeyDealsSelectedPeriodProps {
  dateRange: DateRange;
  keyDeals: KeyDeal[];
  scope: Scope | null;
  company: SignedInCompany | undefined;
  loading?: boolean;
  isMissingCommissionData?: boolean;
}

export function KeyDealsSelectedPeriod({
  dateRange,
  keyDeals,
  scope,
  company,
  loading = false,
  isMissingCommissionData = false,
}: KeyDealsSelectedPeriodProps) {
  if (!dateRange.from || !dateRange.to) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>
            <h2>Key deals for selected period</h2>
          </CardTitle>
          <CardDescription>
            Please select a valid date range from the date picker
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  const fromLabel = format(dateRange.from, "PP");
  const toLabel = format(dateRange.to, "PP");

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <h2>Key deals for selected period</h2>
        </CardTitle>
        <CardDescription>
          {scope?.label.split(" ")[0]}'s top open deals from {fromLabel} to{" "}
          {toLabel}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <CardDescription className="italic">
            Loading key deals...
          </CardDescription>
        ) : keyDeals.length > 0 ? (
          <KeyDealsDataTable
            columns={getKeyDealsColumns(
              company?.default_currency?.code ?? "",
              !isMissingCommissionData
            )}
            keyDeals={keyDeals}
            scope={scope}
          />
        ) : (
          <CardDescription className="italic">
            No open deals in the selected period
          </CardDescription>
        )}
      </CardContent>
    </Card>
  );
}
